module.exports = __webpack_public_path__ + "img/case_background_Image.c5031b35.png";